<template>
    <article
        class="relative w-full lg:w-[240px]"
        v-for="item in listings"
        v-bind:key="'listings' + item.id"
        v-if="listings.length > 0 || hideEmptyState"
    >
        <div
            class="w-full overflow-hidden rounded-2xl bg-green-25 lg:w-[240px]"
        >
            <div class="glide-OFF glide-default-OFF h-[200px]">
                <a :href="item.listing_dashboard_url" class="h-[200px]">
                    <div class="glide__track h-[200px]" data-glide-el="track">
                        <ul class="glide__slides h-[200px]">
                            <template v-if="item.mapped_images.length > 0">
                                <li
                                    v-for="(photo, index) in item.mapped_images"
                                    v-bind:key="
                                        'on_office_photo' + index + item.id
                                    "
                                    class="glide__slide glide__slide--clone"
                                >
                                    <img :src="photo.elements[0].url" alt="" />
                                </li>
                            </template>
                            <!-- <template v-else>
                                <li class="glide__slide glide__slide--clone">
                                    <img
                                        :src="
                                            $assetsUrl +
                                            '/images/image-preview-icon.jpg'
                                        "
                                        alt=""
                                    />
                                </li>
                            </template> -->
                        </ul>
                    </div>
                </a>
            </div>
        </div>
        <div
            class="min-h-[3em]-OFF mt-3.5 line-clamp-2 text-[14px] font-semibold leading-normal"
        >
            <a class="" :href="item.listing_dashboard_url">
                {{ item.elements.objekttitel }}
            </a>
        </div>
        <div
            v-if="(item?.elements?.Id ?? null) !== null"
            class="mt-1 mb-4 text-[12px] leading-none text-black-40"
        >
            <span>Referenčna št.: {{ item.elements.Id ?? 'N/A' }}</span>
        </div>
        <div
            class="mb-3 flex items-center text-[12px] leading-none text-black-40"
        >
            <svg
                width="14"
                height="14"
                class="w-w-[14px] h-w-[14px] mr-2 h-[14px] text-black-40"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 14 14"
            >
                <defs>
                    <clipPath id="map-pin">
                        <path
                            fill="currentColor"
                            stroke="#707070"
                            d="M22 1120h14v14H22z"
                            data-name="Rectangle 2024"
                        ></path>
                    </clipPath>
                </defs>
                <g
                    clip-path="url(#map-pin)"
                    data-name="Mask Group 6598"
                    transform="translate(-22 -1120)"
                >
                    <path
                        fill="currentColor"
                        d="M29 1134a7.25 7.25 0 0 1-3.03-.54q-1.17-.54-1.17-1.38a1.24 1.24 0 0 1 .43-.9 3.14 3.14 0 0 1 1.18-.68l.32 1.01a2 2 0 0 0-.52.25 1.95 1.95 0 0 0-.38.32 2.57 2.57 0 0 0 1.24.6 7.13 7.13 0 0 0 1.93.27 7.22 7.22 0 0 0 1.94-.26 2.58 2.58 0 0 0 1.25-.61 2.68 2.68 0 0 0-.37-.3 2.2 2.2 0 0 0-.53-.27l.3-1.01a3.14 3.14 0 0 1 1.18.68 1.24 1.24 0 0 1 .43.9q0 .83-1.17 1.38a7.25 7.25 0 0 1-3.03.54Zm0-3.76a11.44 11.44 0 0 1 .78-1.25q.41-.57.81-1.08.77-1 1.22-1.71a3.54 3.54 0 0 0 .45-1.9 3.14 3.14 0 0 0-.95-2.3 3.15 3.15 0 0 0-2.31-.95 3.13 3.13 0 0 0-2.31.95 3.14 3.14 0 0 0-.95 2.3 3.54 3.54 0 0 0 .45 1.9q.45.72 1.22 1.72.4.5.81 1.07a11.44 11.44 0 0 1 .78 1.25Zm0 1.9a.6.6 0 0 1-.37-.11.66.66 0 0 1-.23-.32 7.32 7.32 0 0 0-1.04-2.12l-1.23-1.61a9.97 9.97 0 0 1-1.01-1.6 4.58 4.58 0 0 1-.43-2.07 4.16 4.16 0 0 1 1.25-3.06A4.15 4.15 0 0 1 29 1120a4.16 4.16 0 0 1 3.06 1.25 4.16 4.16 0 0 1 1.24 3.05 4.58 4.58 0 0 1-.42 2.07 9.95 9.95 0 0 1-1.02 1.6q-.6.77-1.22 1.61a7.29 7.29 0 0 0-1.04 2.12.7.7 0 0 1-.23.32.58.58 0 0 1-.37.13Zm0-6.79a1 1 0 0 0 .74-.3 1.02 1.02 0 0 0 .31-.75 1 1 0 0 0-.31-.74 1.02 1.02 0 0 0-.74-.3 1 1 0 0 0-.74.3 1.02 1.02 0 0 0-.31.75 1 1 0 0 0 .31.74 1.02 1.02 0 0 0 .74.3Zm0-1.05Z"
                    ></path>
                </g>
            </svg>
            <span class="line-clamp-1">
                <template v-if="item.elements.regionaler_zusatz[0] && locations[item.elements.regionaler_zusatz[0]]">
                    {{ locations[item.elements.regionaler_zusatz[0]].location }}
                </template>
                <template v-else>
                    Naslov še ni podan
                </template>
            </span>
        </div>
        <div class="mb-5 flex gap-9 text-[12px] font-medium leading-none">
            <div class="flex items-center">
                <svg
                    width="16"
                    height="16"
                    class="mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                >
                    <path
                        d="M4.443 11.558h1.589c.157 0 .29.054.396.16a.54.54 0 0 1 .16.398c0 .158-.054.29-.16.395a.54.54 0 0 1-.396.158H3.888a.538.538 0 0 1-.396-.16.538.538 0 0 1-.16-.395V9.969c0-.157.053-.29.16-.396a.54.54 0 0 1 .398-.16.54.54 0 0 1 .554.556v1.59Zm0-7.111v1.589c0 .157-.053.29-.16.396a.54.54 0 0 1-.397.16.54.54 0 0 1-.554-.556V3.89c0-.157.053-.289.16-.395a.538.538 0 0 1 .396-.16h2.144c.157 0 .29.053.396.16a.54.54 0 0 1 .16.397.54.54 0 0 1-.556.554H4.443Zm7.111 7.111V9.97c0-.157.054-.29.16-.396a.54.54 0 0 1 .398-.16.54.54 0 0 1 .554.556v2.145c0 .157-.054.29-.16.396a.538.538 0 0 1-.396.16H9.965a.537.537 0 0 1-.395-.161.54.54 0 0 1-.16-.397.54.54 0 0 1 .556-.554h1.588Zm0-7.111H9.965a.537.537 0 0 1-.395-.16.54.54 0 0 1-.16-.397.54.54 0 0 1 .556-.554h2.144c.157 0 .29.053.396.16.106.106.16.238.16.395v2.145c0 .157-.054.29-.16.396a.54.54 0 0 1-.398.16.54.54 0 0 1-.554-.556V4.447Z"
                        fill="currentColor"
                    ></path>
                </svg>
                <span class="line-clamp-1">
                    <template v-if="item.elements.objektart == 'grundstueck'">
                        {{ item.elements.grundstuecksflaeche }} m²
                    </template>
                    <template v-else>
                        {{ item.elements.wohnflaeche }} m²
                    </template>

                </span>
            </div>
            <div class="flex items-center" v-if="item.elements.objektart != 'grundstueck'">
                <svg
                    width="16"
                    height="16"
                    class="mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                >
                    <path
                        d="M2.556 14a.536.536 0 0 1-.396-.16.54.54 0 0 1-.16-.397.54.54 0 0 1 .556-.554h.91V2.556c0-.158.054-.29.16-.396A.538.538 0 0 1 4.022 2h5.445c.157 0 .289.053.396.16.106.106.16.238.16.396v.166h1.966c.157 0 .29.053.396.16.106.106.16.238.16.396v9.61h.9c.157 0 .289.054.395.161a.54.54 0 0 1 .16.397.54.54 0 0 1-.556.554H11.99a.537.537 0 0 1-.396-.16.538.538 0 0 1-.16-.396v-9.61h-1.41v9.61c0 .158-.054.29-.16.396a.537.537 0 0 1-.396.16H2.556Zm5.566-6a.645.645 0 0 0-.191-.475.645.645 0 0 0-.475-.192.645.645 0 0 0-.475.192.645.645 0 0 0-.192.475c0 .189.064.347.192.475a.645.645 0 0 0 .475.192.645.645 0 0 0 .475-.192A.645.645 0 0 0 8.122 8Zm-3.544 4.889H8.91V3.11H4.578v9.778Z"
                        fill="currentColor"
                    ></path>
                </svg>
                <span class="line-clamp-1">
                    {{ item.elements.anzahl_zimmer }}
                </span>
            </div>
        </div>
        <div class="text-heading-4-bold text-green-49">
            <template v-if="item.elements.vermarktungsart === 'miete'">
                {{ this.$globalFunctions.formatPrice(item.elements.warmmiete) }}
                <span class="text-green">€</span>/ mesec
            </template>

            <template v-else-if="item.elements.vermarktungsart === 'kauf'">
                {{ this.$globalFunctions.formatPrice(item.elements.kaufpreis) }}
                <span class="text-green">€</span>
            </template>

            <template v-else> Cena ni podana </template>
        </div>
        <figure class="flex gap-2 absolute left-4 top-3">
            <template
                v-if="
                    item.elements.status == 2 &&
                    item.elements.status2 == 'status2obj_inaktiv'
                "
            >
                <a
                    class="flex min-h-[38px] items-center justify-center gap-2 rounded-3xl bg-gray px-3 py-2 text-small-text-medium text-black shadow md:min-h-[30px]"
                >
                    <v-icon icon="pause" class="h-[14px] w-[14px]"></v-icon>
                    <label>Deaktivirano</label>
                </a>
            </template>

            <template
                v-if="
                    item.elements.status == 2 &&
                    item.elements.status2 == 'ind_Schl_3269'
                "
            >
                <a
                    class="flex min-h-[38px] items-center justify-center gap-2 rounded-3xl bg-white px-3 py-2 text-small-text-medium text-salmon shadow md:min-h-[30px]"
                >
                    <v-icon icon="x-circle" class="h-[14px] w-[14px]"></v-icon>
                    <label>Odloženo</label>
                </a>
            </template>

            <template v-if="item.elements.status == 1">
                <a
                    class="flex min-h-[38px] items-center justify-center gap-2 rounded-3xl bg-green px-3 py-2 text-small-text-medium text-white shadow md:min-h-[30px]"
                >
                    <v-icon
                        icon="check-circle"
                        class="h-[14px] w-[14px]"
                    ></v-icon>
                    <label>Objavljeno</label>
                </a>
            </template>

            <template
                v-if="
                    item.elements.status == 2 &&
                    item.elements.status2 == 'vorbereitung'
                "
            >
                <a
                    class="flex min-h-[38px] items-center justify-center gap-2 rounded-3xl bg-gray px-3 py-2 text-small-text-medium text-black shadow md:min-h-[30px]"
                >
                    <v-icon icon="hourglass" class="h-[14px] w-[14px]"></v-icon>
                    <label>V pregledu{{item.payment_done ? ' (Plačano)' : ''}}</label>
                </a>
            </template>

            <template
                v-if="
                    item.active_payment
                "
            >
                <a
                    class="flex min-h-[38px] items-center justify-center gap-2 rounded-3xl bg-salmon px-3 py-2 text-small-text-medium text-white shadow md:min-h-[30px]"
                    title="Plačilo v teku"
                >
                    <v-icon icon="payments" class="h-[14px] w-[14px]"></v-icon>
                </a>
            </template>
        </figure>
    </article>
    <section class="w-full" v-else>
        <div
            class="flex h-full min-h-full w-full flex-col items-center justify-center lg:col-span-3 lg:row-span-3 lg:pb-16 lg:pt-16"
        >
            <img
                class="h-[120px] w-[120px] lg:h-[190px] lg:w-[190px]"
                :src="'/assets/images/hisa-ponoci.webp'"
            />
            <div
                class="mt-5 text-center text-heading-2-mobile text-black-78 lg:mt-6 lg:text-heading-1-mobile"
            >
                Izgleda malo prazno...
            </div>
            <hr class="mb-6 mt-6 w-full max-w-xl lg:mb-11 lg:mt-11" />
            <a
                :href="headerSetupData.createListingRoute"
                class="button button--white shadow"
            >
                <v-icon icon="add-listing"></v-icon>
                Objavite oglas
            </a>
            <div
                class="mt-6 max-w-[371px] text-center text-body-regular text-black-40"
            >
                Enostavno objavite oglas nepremičnine v parih preprostih korakih
                in ga oglašujte na najnovejšem nepremičninskem portalu v
                Sloveniji.
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        listings: {
            type: Object,
            required: true,
        },
        locations: {
            type: Object,
            required: true,
        },
        headerSetupData: {
            type: Object,
            required: true,
        },
        hideEmptyState: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            showAll: true,
            showListed: false,
            showDeactivated: false,
            showDrafts: false,
            showRejected: false,
        };
    },
    mounted() {
        console.log(this.listings);
    },
    methods: {},
};
</script>
